export default "__VITE_ASSET__CchEHCr3__"